module.exports = __webpack_public_path__ + "assets/img/CreateAccount@2x.45ceca36.png";